module.exports = __webpack_public_path__ + "assets/img/1424.be18c609.png";